
import { TOGGLE_NEW_PASS } from './ui-control'
import { api } from '../util/mock/index'
import { getPassesFromHistory } from '../util/selectors'
export const CREATE_PASS_REQUESTED = 'pass-list/CREATE_PASS_REQUESTED'
export const CREATE_PASS_SUCCEEDED = 'pass-list/CREATE_PASS_SUCCEEDED'
export const UPDATE_PASS_TO_CREATE_FIELD = 'pass-list/UPDATE_PASS_TO_CREATE_FIELD'
export const LOCATION_CHANGE = "@@router/LOCATION_CHANGE"
export const VALIDATE_NEW_PASS = 'pass-list/VALIDATE_NEW_PASS'
export const CANCEL_CREATE_PASS_REQUESTED = 'pass-list/CANCEL_CREATE_PASS_REQUESTED'
export const CANCEL_CREATE_PASS = 'pass-list/CANCEL_CREATE_PASS'
export const RESUME_CREATE_PASS = 'pass-list/RESUME_CREATE_PASS'
export const GET_HISTORY_SUCCESS = 'pass-list/GET_HISTORY_SUCCESS'
export const GET_PASSES = 'pass-list/GET_PASSES'
export const GET_PASSES_SUCCESS = 'pass-list/GET_PASSES_SUCCESS'


const initialState = {
  passes: [],
  history: [],
  isCreating: false,
  isConfirmationDialogOpen: false,
  passToCreate: {
    guest_name: ""
  }
};


export default (passList = initialState, action) => {
  switch (action.type) {
    case LOCATION_CHANGE:
      if (action.payload.pathname === "/pass") {
        return { ...passList, isCreating: true }
      } else {
        return { ...passList, isCreating: false }
      }
    case UPDATE_PASS_TO_CREATE_FIELD:
      const field = action.field,
        value = action.value;
      const passToCreate = { ...passList.passToCreate };
      passToCreate[field] = value;
      return {
        ...passList,
        passToCreate
      }
    case CREATE_PASS_REQUESTED:
      return {
        ...passList,
        isCreating: true
      }
    case CREATE_PASS_SUCCEEDED:
      return {
        ...passList,
        isCreating: !passList.isCreating,
        passToCreate: initialState.passToCreate
      }
    case RESUME_CREATE_PASS:
      return {
        ...passList,
        isConfirmationDialogOpen: false,
        isCreating: true
      }
    case CANCEL_CREATE_PASS:
      return {
        ...passList,
        isConfirmationDialogOpen: false,
        passToCreate: initialState.passToCreate
      }
    case CANCEL_CREATE_PASS_REQUESTED:
      return {
        ...passList,
        isConfirmationDialogOpen: true
      }
    case GET_HISTORY_SUCCESS:
      const history = action.history;
      const passes = getPassesFromHistory(history);
      return {
        ...passList,
        history: [...history],
        passes: [...passes]
      }
    default:
      return passList
  }
}


export const createPassRequested = (e) => {
  return (dispatch, getState) => {
    const pass = {
      ...getState().passList.passToCreate
    };
    dispatch({
      type: CREATE_PASS_REQUESTED
    });
    api.putPass(pass, function (err) {
      api.getHistory(function (err, history) {
        if (err) {
          throw new Error("getHistory err unhandled")
        }
        dispatch({ type: GET_HISTORY_SUCCESS, history })
        dispatch({ type: TOGGLE_NEW_PASS });
        dispatch({ type: CREATE_PASS_SUCCEEDED });
      });
    });
  }
}
export const updatePassToCreateField = (e) => {
  const data = e.nativeEvent.data;
  return dispatch => {
    dispatch({ type: UPDATE_PASS_TO_CREATE_FIELD, value: e.target.value, field: e.target.id, data })
  }
}
export const cancelCreatePass = (e) => {
  return dispatch => {
    dispatch({ type: CANCEL_CREATE_PASS });
    dispatch({ type: TOGGLE_NEW_PASS });
  }
}
export const resumeCreatePassForm = (e) => {
  return dispatch => {
    dispatch({ type: RESUME_CREATE_PASS })
  }
}
export const getHistory = (e) => {
  return dispatch => {
    api.getHistory((err, history) => {
      if (err) {
        throw new Error("getHistory err unhandled")
      }
      dispatch({ type: GET_HISTORY_SUCCESS, history })
    })
  }
}



// WEBPACK FOOTER //
// ./src/reducers/pass-list.js